<template>
  <div class="pd-40">
    <div class="order-detail-page">
      <div class="container">
        <!-- Header with back button -->
        <div class="page-header">
          <button class="back-btn" @click="$router.go(-1)">
            <svg
              viewBox="0 0 24 24"
              width="24"
              height="24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
          </button>
          <h1 class="page-title">Order detail</h1>
        </div>

        <div class="content-layout" v-if="orderData.id">
          <!-- Sidebar (Right) -->
          <aside class="main-content">
            <div class="product-summary">
              <div class="product-header">
                <img
                  :src="urls + orderData.productimage"
                  alt="product"
                  class="summary-image"
                />
                <div class="summary-info">
                  <span class="summary-tag">Cash back survey</span>
                  <h3 class="summary-title">{{ orderData.productname }}</h3>
                </div>
              </div>

              <div class="price-breakdown">
                <h3 class="breakdown-title">Your total</h3>
                <div class="price-row">
                  <span>Original price</span>
                  <span>${{ orderData.productoriginprice }}</span>
                </div>
                <div class="price-row" v-if="orderData.cashbackmoney">
                  <span>Cashback after 30 days</span>
                  <span style="color: #00d4aa">-${{ orderData.cashbackmoney }}</span>
                </div>
                <div class="price-row" v-if="orderData.couponmoney">
                  <span>Coupon</span>
                  <span style="color: #00d4aa"
                    >-${{ orderData.couponmoney }}</span
                  >
                </div>

                <div class="price-row total-row">
                  <span>Price after cash back</span>
                  <span class="final-price">${{ orderData.productprice }}</span>
                </div>
              </div>
            </div>
            <!-- <div class="terms-text3">Invite-only fast cashback channel</div>
            <div class="terms-text2">{{ orderData.channelremark }}</div> -->
            
            <div class="mt-20">
              <button
                class="confirm-btn"
                style="background: rgb(255, 194, 0)"
                @click="handleToAmazon"
              >
                Buy at full price on Amazon
              </button>
            </div>
          </aside>
          <!-- Main Content (Left) -->
          <div class="sidebar">
            <!-- Order Status Section -->
            <section class="info-section">
              <h2 class="section-title">Order Info</h2>
              <div class="info-grid">
                <div class="info-item">
                  <span class="info-label">Order Number</span>
                  <span class="info-value">{{ orderData.orderno }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Order Status</span>
                  <span
                    class="info-value status-text"
                    :class="{ completed: orderData.status === '2' }"
                  >
                    {{
                      orderData.status === "0"
                        ? "Confirm order"
                        : orderData.status === "1"
                        ? "Pending approval"
                        : "Completed"
                    }}
                  </span>
                </div>
                <div class="info-item">
                  <span class="info-label">Order Date</span>
                  <span class="info-value">{{
                    formatDate(orderData.createtime)
                  }}</span>
                </div>
                <div class="info-item" v-if="orderData.couponcode">
                  <span class="info-label">Coupon Code</span>
                  <span class="info-value coupon-code">{{
                    orderData.couponcode
                  }}</span>
                </div>
                <div class="info-item" v-if="orderData.remark">
                  <span class="info-label">Order Remark</span>
                  <span class="info-value">{{ orderData.remark }}</span>
                </div>
              </div>
            </section>

            <!-- Transfer Images Section -->
            <section class="info-section" v-if="transferImagesList.length > 0">
              <h2 class="section-title">Transfer Screenshots</h2>
              <div class="transfer-images-grid">
                <div
                  v-for="(img, index) in transferImagesList"
                  :key="index"
                  class="transfer-image-item"
                >
                  <img
                    :src="img"
                    alt="transfer screenshot"
                    @click="handlePreviewImage(img)"
                  />
                </div>
              </div>
            </section>

            <!-- Deal Section -->
            <!-- <section class="info-section">
              <h2 class="section-title">Your deal</h2>
              <div class="info-grid">
                <div class="info-item">
                  <span class="info-label">Cash back</span>
                  <span class="info-value">${{ cashBack }}</span>
                </div>
              </div>
            </section> -->

            <!-- Terms Section -->
            <!-- <div class="terms-text" v-html="orderdescription"></div> -->
            <div class="terms-text" style="text-align: center">
              Forward us the order confirmation email
            </div>
            <!-- Back to list button -->
            <button class="confirm-btn" @click="showOrderModal = true">
              {{ email || "rebates@koiodeal.com" }}
            </button>
            <a :href="'https://wa.me/' + contactPhone.replace(/[^0-9]/g, '')" target="_blank" style="display: block;margin-top: 20px; text-align: center; color: #25d366">
              More information on quick cashback,pls contact us via Whatsapp
            </a>
            <a :href="'https://wa.me/' + contactPhone.replace(/[^0-9]/g, '')" target="_blank" style="display: block;margin-top: 20px; text-align: center;">
              <img style="width: 40px;" src="@/assets/images/phone.webp" alt="">
            </a>
            <!-- <button class="confirm-btn" style="margin-left: 10px; background: #666;" @click="$router.push('/snags')">Back to My Snags</button> -->
          </div>
        </div>
        <div class="loading-state" v-else>
          <p>Loading order details...</p>
        </div>
        <!-- Confirm Order Modal -->
        <div
          class="modal-overlay"
          v-if="showOrderModal"
          @click.self="showOrderModal = false"
        >
          <div class="confirm-modal">
            <div class="modal-header">
              <button class="close-modal-btn" @click="showOrderModal = false">
                <svg
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
              <h2 class="modal-title">Confirm your order</h2>
            </div>
            <div class="modal-body">
              <p class="modal-desc">
                After you order the product, you will receive an email
                confirming your order. Forward that order confirmation email to
                the email address below.
              </p>

              <div class="modal-action-list">
                <div class="modal-action-item" @click="handleCopyEmail">
                  <div class="action-left">
                    <div class="action-icon">
                      <svg
                        viewBox="0 0 24 24"
                        width="20"
                        height="20"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <rect
                          x="9"
                          y="9"
                          width="13"
                          height="13"
                          rx="2"
                          ry="2"
                        ></rect>
                        <path
                          d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                        ></path>
                      </svg>
                    </div>
                    <div class="action-text">
                      <div class="action-label">Copy email address</div>
                      <div class="action-subtext">{{ email }}</div>
                    </div>
                  </div>
                  <div class="action-arrow">
                    <svg
                      viewBox="0 0 24 24"
                      width="20"
                      height="20"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </div>
                </div>

                <div class="modal-action-item" @click="handleLearnMore">
                  <div class="action-left">
                    <div class="action-icon">
                      <svg
                        viewBox="0 0 24 24"
                        width="20"
                        height="20"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <rect
                          x="2"
                          y="5"
                          width="20"
                          height="14"
                          rx="2"
                          ry="2"
                        ></rect>
                        <path d="m10 15 5-3-5-3v6Z"></path>
                      </svg>
                    </div>
                    <div class="action-text">
                      <div class="action-label">
                        Learn how to confirm your order
                      </div>
                    </div>
                  </div>
                  <div class="action-arrow">
                    <svg
                      viewBox="0 0 24 24"
                      width="20"
                      height="20"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { productApi, commonApi } from "@/api/index.js";

export default {
  name: "OrderDetail",
  data() {
    return {
      orderData: {},
      urls: this.httpUrl,
      orderdescription: "",
      showOrderModal: false,
      videolink: "",
      email: `rebates${Math.floor(10000 + Math.random() * 90000)}@koiodeal.com`,
      contactPhone:"",
    };
  },
  computed: {
    transferImagesList() {
      if (!this.orderData.transferimages) return [];
      return this.orderData.transferimages
        .split(",")
        .filter((img) => img)
        .map((img) => {
          return img.startsWith("http") ? img : this.urls + img;
        });
    },
    cashBack() {
      const origin = parseFloat(this.orderData?.productoriginprice) || 0;
      const current = parseFloat(this.orderData?.productprice) || 0;
      const diff = origin - current;
      return diff > 0 ? diff.toFixed(2) : "0.00";
    },
  },
  async mounted() {
    const id = this.$route.params.id;
    await this.loadOrderDetail(id);
    this.loadConfig();
  },
  methods: {
    handleCopyEmail() {
      const email = this.email;
      const textarea = document.createElement("textarea");
      textarea.value = email;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        this.$toast("Email copied to clipboard!");
      } catch (err) {
        console.error("Failed to copy email:", err);
        this.$toast("Failed to copy email");
      }
      document.body.removeChild(textarea);
    },
    handlePreviewImage(url) {
      window.open(url, "_blank");
    },
    handleLearnMore() {
      // Open a YouTube link or tutorial
      window.open(this.videolink, "_blank");
    },
    handleToAmazon() {
      window.open(this.orderData.urllink, "_blank");
    },
    async loadConfig() {
      try {
        const res = await commonApi.getConfig();
        this.orderdescription = res.data.orderdescription || "";
        this.videolink = res.data.videolink || "";
        this.contactPhone = res.data.phone || "";
        // this.email = res.data.email || ''
      } catch (e) {
        console.error("Failed to load config:", e);
      }
    },
    async loadOrderDetail(id) {
      try {
        const res = await productApi.getOrderDetail(id);
        if (res.code === 1) {
          this.orderData = res.data;
        }
      } catch (e) {
        console.error("Failed to load order detail:", e);
        this.$toast("Failed to load order details");
      }
    },
    formatDate(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp * 1000);
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      const h = String(date.getHours()).padStart(2, "0");
      const min = String(date.getMinutes()).padStart(2, "0");
      const s = String(date.getSeconds()).padStart(2, "0");
      return `${y}-${m}-${d} ${h}:${min}:${s}`;
    },
  },
};
</script>

<style scoped>
.pd-40 {
  padding: 40px;
}

.order-detail-page {
  background: #fdfdfd;
  min-height: 100vh;
  /* padding: 40px 0; */
  color: #333;
}
.mt-20 {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
}

.page-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
  padding-bottom: 20px;
}

.back-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  color: #666;
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 28px;
  font-weight: 500;
  margin: 0;
}

.content-layout {
  display: flex;
  gap: 40px;
}

.main-content {
  flex: 1;
}

.info-section {
  margin-bottom: 35px;
}

.section-title {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 20px;
}

.info-grid {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.info-item {
  display: flex;
  flex-direction: column;
}

.info-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
}

.info-value {
  font-size: 18px;
  font-weight: 400;
}

.transfer-images-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.transfer-image-item {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #eee;
  cursor: pointer;
}

.transfer-image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.status-text {
  color: #ff9800;
  font-weight: 600;
}

.status-text.completed {
  color: #00d4aa;
}

.coupon-code {
  color: #00d4aa;
  font-weight: 700;
  letter-spacing: 1px;
}

.terms-text {
  text-align: left;
  font-size: 12px;
  color: #999;
  line-height: 1.6;
  margin-bottom: 25px;
}
.terms-text3 {
  text-align: left;
  font-size: 18px;
  color: #333;
  line-height: 1.6;
  margin-bottom: 25px;
  margin-top: 20px;
  font-weight: 500;
}
.terms-text2 {
  text-align: left;
  font-size: 14px;
  color: #999;
  line-height: 1.6;
  margin-bottom: 25px;
}

.terms-text2 a {
  color: #666;
  text-decoration: underline;
}
.confirm-btn {
  background: #1e2d3b;
  color: white;
  border: none;
  padding: 15px 50px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s;
}

.confirm-btn:hover {
  opacity: 0.9;
}

/* Sidebar styles */
.sidebar {
  width: 350px;
}

.product-summary {
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 20px;
  background: white;
}

.product-header {
  display: flex;
  gap: 15px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.summary-image {
  width: 80px;
  height: 80px;
  object-fit: contain;
  border-radius: 8px;
}

.summary-info {
  flex: 1;
}

.summary-tag {
  font-size: 12px;
  color: #999;
  display: block;
  margin-bottom: 4px;
}

.summary-title {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 8px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.price-breakdown {
  padding-top: 20px;
}

.breakdown-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 15px;
}

.price-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 15px;
  color: #666;
}

.total-row {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  color: #333;
  font-weight: 500;
}

.final-price {
  font-size: 18px;
  font-weight: 700;
}

.loading-state {
  text-align: center;
  padding: 100px 0;
  color: #999;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.confirm-modal {
  background: white;
  width: 90%;
  max-width: 600px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  animation: modalFadeIn 0.3s ease-out;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  padding: 20px;
  position: relative;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
}

.close-modal-btn {
  position: absolute;
  left: 20px;
  top: 20px;
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-modal-btn:hover {
  color: #333;
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #333;
  width: 100%;
}

.modal-body {
  padding: 24px;
}

.modal-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0 0 24px 0;
}

.modal-action-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.modal-action-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #f8f8f8;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.modal-action-item:hover {
  background: #f0f0f0;
}

.action-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.action-icon {
  color: #333;
  display: flex;
  align-items: center;
}

.action-label {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  text-align: left;
}

.action-subtext {
  font-size: 13px;
  color: #888;
  margin-top: 2px;
}

.action-arrow {
  color: #ccc;
  display: flex;
  align-items: center;
}

@media (max-width: 768px) {
  .content-layout {
    flex-direction: column;
  }
  .sidebar {
    width: 100%;
  }
  .pd-40 {
    padding: 10px;
  }
}
</style>
